<div
  class="switch-container"
  [attr.data-size]="size"
  [attr.data-checked]="checked"
  [attr.data-disabled]="disabled"
>
  <button
    type="button"
    class="switch-track"
    role="switch"
    [attr.aria-checked]="checked"
    [attr.aria-label]="computedAriaLabel"
    [attr.aria-required]="required"
    [disabled]="disabled"
    (click)="onToggle()"
    (focus)="onFocusEvent()"
    (blur)="onBlurEvent()"
  >
    <span class="switch-thumb"></span>
  </button>
</div>
